import Combobox from './combobox';
import { ready, fetchApiUrl } from './utilities';

// Support both standard page load and Turbolinks navigation
ready(init);
document.addEventListener('turbolinks:load', init);

async function init() {
  const stockFilterElem = document.querySelector('#analyst-stock-filter');
  
  if (!stockFilterElem) {
    return;
  }

  // Prevent double initialization
  if (stockFilterElem.dataset.comboboxInitialized) {
    return;
  }
  stockFilterElem.dataset.comboboxInitialized = "true";

  const selectedStock = new URLSearchParams(window.location.search).get('query');
  
  new Combobox({
    valueKey: 'symbol',
    selected: selectedStock,
    root: stockFilterElem,
    search: async (text) => {
      // Nur suchen wenn mindestens 2 Zeichen eingegeben wurden
      if (!text || text.length < 2) {
        return [];
      }
      const stocksReq = await fetchApiUrl('/api/v1/stocks?query=' + (text || ''));
      const stocks = await stocksReq.json();
      return stocks;
    },
    render: (stock) => {
      const div = document.createElement('div');
      div.textContent = `${stock.name} (${stock.symbol})`;
      return div;
    },
    update: (value) => {
      // Wenn ein Wert ausgewählt wurde, die Seite neu laden mit dem Query-Parameter
      const url = new URL(window.location.href);
      if (value) {
        url.searchParams.set('query', value);
      } else {
        url.searchParams.delete('query');
      }
      window.location.href = url.toString();
    }
  });
}
